import __var_0__ from '@stdlib/assert/is-number';
import __var_1__ from '@stdlib/assert/is-positive-number';
import __var_2__ from '@stdlib/assert/is-nan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isNumber = __var_0__.isPrimitive;
var isPositive = __var_1__.isPrimitive;
var isnan = __var_2__;


// MAIN //

/**
* Validates parameters.
*
* @private
* @param {number} mu - location parameter
* @param {PositiveNumber} s - scale parameter
* @returns {(Error|null)} error or null
*
* @example
* var err = validate( 1.0, 2.0 );
* if ( err ) {
*     throw err;
* }
*/
function validate( mu, s ) {
	if ( !isNumber( mu ) || isnan( mu ) ) {
		return new TypeError( 'invalid argument. `mu` must be a number primitive and not `NaN`. Value: `' + mu + '`.' );
	}
	if ( !isPositive( s ) ) {
		return new TypeError( 'invalid argument. `s` must be a positive number. Value: `' + s + '`.' );
	}
	return null;
}


// EXPORTS //
export default validate;
